import React from 'react';
import { Banner } from 'components/ui/banner';

const Restricted = (): JSX.Element => (
  <div className="mt-3 max-w-3xl mx-4 sm:mx-0">
    <Banner
      variant="warning"
      message="You are currently not approved for Virtual Terminal."
      details={
        <>
          Please contact your TreezPay Account Manager or
          <a
            className="ml-1 text-dark-green-link underline"
            target="_blank"
            rel="noreferrer"
            href="https://support.treez.io/hc/en-us/requests/new"
          >
            contact support
          </a>{' '}
          in case there are any queries.
        </>
      }
    />
  </div>
);

export default Restricted;
